var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.field.componentName,{tag:"component",attrs:{"field":_vm.field,"value":_vm.getFieldValue,"readonly":_vm.readonly,"outlined":_vm.field.outlined,"validations":_vm.validations},on:{"fieldChange":_vm.setFieldValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }